import React, { useEffect } from "react";
import { dateToString } from "~/utils/formatter";

import {
	PaginationEdgeIcon,
	PaginationIcon,
	SearchIcon,
	CautionIcon,
} from "~/assets/svg/InterfaceIcon";
import LoadingPage from "~/pages/LoadingPage";
import { useTranslation } from "react-i18next";
import { TRANS_INDUSTRY_CATEGORY_LIST } from "~/constant/ApplyFormConstant";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";
import { useNavigate, useSearchParams } from "react-router-dom";
import Pagination from "~/pages/apply/ApplyList/util/Pagination";
import pageMaker from "~/common/constants/pageMaker";
const ApplyEvalTable = ({
	loadingPage,
	getDetailModal,
	applyJudgeList,
	onChangeName,
	handleSearch,
							handlePage, pageInfo
}) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const modalIdx = searchParams.get("modalIdx");
	const pagingInfo = pageMaker(pageInfo.page, pageInfo.size, pageInfo.totalCount);

	const [
		{
			sidebar: { currentPath },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	useEffect(() => {
		if (!applyJudgeList) return;
		if (!modalIdx) return;
		getDetailModal(modalIdx);
		navigate("/apply/evaluate");
	}, [applyJudgeList]);


	return (
		<div className="c__card">
			<div className="c__search">
				<input
					className="c__input"
					placeholder={t("pages.apply.ApplyEval.ApplyEvalTable.companyNameInput")}
					onChange={onChangeName}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							handleSearch();
						}
					}}
				/>
				<button type="button" className="btn-search" onClick={handleSearch}>
					<SearchIcon />
				</button>
			</div>
			<div className="c__table">
				<div className="thead">
					<div className="tr">
						<div className="th num">No</div>
						<div className="th company">
							{t("pages.apply.ApplyEval.ApplyEvalTable.company")}
						</div>
						<div className="th company">
							{t("pages.apply.ApplyEval.ApplyEvalTable.present")}
						</div>
						<div className="th type">
							{t("pages.apply.ApplyEval.ApplyEvalTable.industryType")}
						</div>
						<div className="th review">
							심사역
						</div>
						<div className="th date">
							{t("pages.apply.ApplyEval.ApplyEvalTable.applyDate")}
						</div>
						<div className="th judge">
							{t("pages.apply.ApplyEval.ApplyEvalTable.judge")}
						</div>
					</div>
				</div>
				<div className="tbody">
					{!loadingPage ? (
						applyJudgeList && applyJudgeList.length > 0 ? (
							applyJudgeList.map((item, idx) => {
								let fieldList = [];
								item.startup.industryField
									?.split(",")
									.map((field) =>
										fieldList.push(TRANS_INDUSTRY_CATEGORY_LIST[field] || field)
									);
								return (
									<div
										className="tr"
										onClick={() => {
											if (currentPath.auth !== "edit") {
												showAuthAlert();
												return;
											}
											getDetailModal(item.idx);
										}}
										key={idx}
									>
										<div className="td num">{pageInfo.totalCount - (pageInfo.size * (pageInfo.page - 1) + idx)}</div>
										<div className="td company">{item.startup.name}</div>
										<div className="td company">{item.startup.ceo}</div>
										<div className="td type"> {fieldList.join()}</div>
										<div className="td review">
											{
												item?.judges?.map((judge, idx) => (
													(idx > 0) ?
														<>, <span key={judge?.user?.name + idx}>{judge?.user?.name}</span></> :
														<span key={judge?.user?.name + idx}>{judge?.user?.name}</span>
												))
											}
											{
												(!item?.judges || item?.judges?.length <= 0) && <span>-</span>
											}
										</div>
										<div className="td date">
											{dateToString(item.createdAt, "yyyy-MM-dd")}
										</div>
										<div className="td judge">
											{item.status === "심사대기" ||
											item.status === "심사중" ? (
												<button
													type="button"
													className="btn__outline angled"
													color="primary"
												>
													{t(
														"pages.apply.ApplyEval.ApplyEvalTable.evaluate"
													)}
												</button>
											) : (
												<button
													type="button"
													className="btn__outline angled"
													color="gray"
												>
													{t(
														"pages.apply.ApplyEval.ApplyEvalTable.result"
													)}
												</button>
											)}
										</div>
									</div>
								);
							})
						) : (
							//---- Empty
							<div className="c__noData apply">
								<CautionIcon />
								<p className="main">
									{t("pages.apply.ApplyEval.ApplyEvalTable.noCompanyMessage")}
								</p>
							</div>
						)
					) : (
						<LoadingPage />
					)}
				</div>
			</div>
			<Pagination pageInfo={pagingInfo} handlePage={handlePage} />

			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</div>
	);
};

export default ApplyEvalTable;
